import React, { useEffect, useState } from "react";
import { Card, Button } from "antd";
import moment from "moment";
import { ToWords } from "to-words";
import logo from "../../../../../../../apps/ui/masters-ui/src/app/spsa logo.png";

const toWords = new ToWords({ localeCode: "en-IN" });

export interface QaqcFiberPrintProps {
  record: any;
}

export function QaqcFiberPrint(props: QaqcFiberPrintProps) {
  const [data, setData] = useState<any>(props.record);

  useEffect(() => {
    setData(props.record);
  }, [props.record]);

  const printPage = () => {
    const content = document.getElementById("print-area");

    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=650");

    if (printWindow) {
      printWindow.document.write(`
      <html>
        <head>
          <title>QAQC Certificate Print</title>
          <style>
            @page {
              size: A4;
              margin: 10mm;
            }

            body {
              margin: 0;
              padding: 0;
              font-family: Arial;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            img {
              max-width: 100%;
            }

            button {
              display: none !important;
            }

          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const header = data;

  return (
    <Card
      title="SILK FIBER ANALYSIS CERTIFICATE"
      extra={<Button onClick={printPage}>Print</Button>}
      style={{ width: "100%", margin: 0 }}
      headStyle={{ textAlign: "center", background: "#69c0ff" }}
    >
      <div id="print-area" style={{ padding: 20, position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            opacity: 0.12, 
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          {/* <img
            src={logo}
            alt="watermark"
            style={{
              width: 600,   
              height: "auto",
            }}
          /> */}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            {/* <img src={logo} alt="logo" style={{ height: 80 }} /> */}
          </div>

          <div style={{ textAlign: "center" }}>
            <h2 style={{ margin: 0 }}>S.P.S.A SILKS PVT LTD</h2>
            <p style={{ margin: 0 }}>SILK FIBER ANALYSIS CERTIFICATE</p>
          </div>
          <div></div>
          
        </div>

        <table style={{ width: "100%", marginBottom: 20 }}>
          <tbody>
            <tr>
              <td>
                <b>Lot Number:</b> {header?.lotNumber || "-"}
              </td>
              <td>
                <b>Test Date:</b>{" "}
                {header?.testDate
                  ? header.testDate
                  : "-"}
              </td>
            </tr>
            
          </tbody>
        </table>

        <div style={{ marginBottom: 20 }}>
          <p>
            <b>Material:</b> {header?.product || "-"}
          </p>
          
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: 20,
          }}
        >
          <thead>
            <tr>
              <th style={th}>Mean length</th>
              <th style={th}>Longest fiber</th>
              <th style={th}>Shortest fiber</th>
              <th style={th}>% of short fiber</th>
              <th style={th}>Slub</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={td}>{header?.meanLength || "-"}</td>
              <td style={td}>{header?.longestFiber || "-"}</td>
              <td style={td}>{header?.shortestFiber || "-"}</td>
              <td style={td}>{header?.shortFiberPercent || "-"}</td>
              <td style={td}>{header?.slub || "-"}</td>
            </tr>
          </tbody>
        </table>

        {header?.remarks && (
          <div style={{ marginBottom: 20 }}>
            <b>Remarks:</b> {header.remarks}
          </div>
        )}

        <table style={{ width: "100%", marginTop: 60 }}>
          <tbody>
            <tr>
              <td style={signTd}></td>
              <td style={signTd}></td>
              <td style={signTd}></td>
            </tr>
            <tr>
              <td style={signTd}>QC</td>
              <td style={signTd}></td>
              <td style={signTd}>HOD</td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}

const th = {
  border: "1px solid black",
  padding: 10,
  background: "#fafafa",
};

const td = {
  border: "1px solid black",
  padding: 10,
  textAlign: "center" as const,
};

const signTd = {
  width: "33.33%",        
  textAlign: "center" as const,
  paddingTop: 20,
};
